import type { FragmentOf } from "@opensea/graphql"
import { readFragment } from "@opensea/graphql"
import {
  BottomSheetBody,
  BottomSheetHeader,
  BottomSheetHeaderTitle,
  Flex,
  FlexCenter,
  Separator,
  SpaceBetween,
  TextBody,
} from "@opensea/ui-kit"
import { useTranslations } from "use-intl"
import { BackButton } from "../../../../../components/BackButton/BackButton"
import type { TransferFlowFormValues } from "../../types"
import { TransferFlowReviewItems } from "../TransferFlowReviewItems"
import { TransferFlowTimeline } from "../TransferFlowTimeline"
import { TransferFlowReview_itemFragment } from "./TransferFlowReview.fragment"

type Props = {
  onBack: () => void
  onSuccess?: () => void
  onError?: (error: Error) => void
  items: FragmentOf<typeof TransferFlowReview_itemFragment>[]
  formValues: TransferFlowFormValues
}

export function TransferFlowReview({
  onBack,
  onSuccess,
  onError,
  items: itemKeys,
  formValues,
}: Props) {
  const t = useTranslations("wallet.TransferFlowReview")
  const items = itemKeys.map(item =>
    readFragment(TransferFlowReview_itemFragment, item),
  )

  return (
    <>
      <BottomSheetHeader>
        <BottomSheetHeaderTitle
          className="cursor-pointer"
          onClick={() => onBack()}
        >
          <FlexCenter className="gap-3">
            <BackButton />
            <Separator className="h-4 text-secondary" orientation="vertical" />
            {t("reviewTransfer", { count: formValues.items.length })}
          </FlexCenter>
        </BottomSheetHeaderTitle>
      </BottomSheetHeader>
      <BottomSheetBody>
        <SpaceBetween className="h-[68px] items-center">
          <TextBody weight="semibold">{t("sendTo")}</TextBody>
          <TextBody>{formValues.recipient.identifier}</TextBody>
        </SpaceBetween>

        <Separator className="my-0.5" />

        <TransferFlowReviewItems formValues={formValues} items={items} />

        <Separator className="my-0.5" />

        <Flex className="w-full pt-4 pb-6">
          <TransferFlowTimeline
            formValues={formValues}
            items={items}
            onBack={onBack}
            onError={onError}
            onSuccess={onSuccess}
          />
        </Flex>
      </BottomSheetBody>
    </>
  )
}
